import React from 'react';
import PropTypes from 'prop-types';

const PriceText = ({priceData}) => {
	if (!priceData) {
		return null;
	}

	return `${priceData.price} ${priceData.curr}`;
};

PriceText.propTypes = {
	priceData: PropTypes.object.isRequired
};

export default PriceText;